import { META_ATTRS_PROPERTY } from '../utils/decorators/json-convert';

export class AbstractModel {
    constructor() {
        const proto = this['__proto__'];
        const attrs: string[] = proto[META_ATTRS_PROPERTY];

        if (attrs) {
            attrs.forEach(attr => {
                if (!this.hasOwnProperty(attr)) {
                    this[attr] = undefined;
                }
            })
        }
    }
}